import React from "react";
import { Nav, Tab, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./SystemConfigPanel.scss";

const SystemConfig = () => {
  const { t } = useTranslation();

  return (
    <div className="dbCon SystemConfig">
      <div className="dbRight">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="PaymentSettings"
        >
          <Nav variant="pills" className="tabs mb-3">
            <Nav.Item>
              <Nav.Link eventKey="PaymentSettings">{t("payment_settings")}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="NotificationTemplates">
                {t("notification_templates")}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="PricingRules">{t("pricing_rules")}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="SystemSettings">{t("system_settings")}</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            {/* Payment Settings */}
            <Tab.Pane eventKey="PaymentSettings">
              <h4>{t("payment_gateway_integration")}</h4>
              <form>
                <div className="mb-3">
                  <label className="form-label">{t("gateway_provider")}</label>
                  <select className="formSelect">
                    <option>Stripe</option>
                    <option>PayPal</option>
                    <option>Razorpay</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">{t("api_key")}</label>
                  <input
                    type="text"
                    placeholder={t("enter_api_key")}
                    className="formInput"
                  />
                </div>
                <Button variant="primary" className="mt-3">
                  {t("btns.save")}
                </Button>
              </form>
            </Tab.Pane>

            {/* Notification Templates */}
            <Tab.Pane eventKey="NotificationTemplates">
              <h4>{t("email_notification_templates")}</h4>
              <form>
                <div className="mb-3">
                  <label className="form-label">{t("template_type")}</label>
                  <select className="formSelect">
                    <option>{t("booking_confirmation")}</option>
                    <option>{t("payment_success")}</option>
                    <option>{t("seat_cancellation")}</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">{t("template_content")}</label>
                  <textarea
                    rows={5}
                    placeholder={t("enter_email_message")}
                    className="formInput"
                  />
                </div>
                <Button variant="primary" className="mt-3">
                  {t("save_template")}
                </Button>
              </form>
            </Tab.Pane>

            {/* Pricing Rules */}
            <Tab.Pane eventKey="PricingRules">
              <h4>{t("pricing_rule_settings")}</h4>
              <form>
                <div className="mb-3">
                  <label className="form-label">{t("base_price_per_seat")}</label>
                  <input
                    className="formInput"
                    type="number"
                    placeholder="e.g., 30"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    {t("zone_based_additional_fee")}
                  </label>
                  <input
                    className="formInput"
                    type="number"
                    placeholder="e.g., 5"
                  />
                </div>
                <Button variant="primary" className="mt-3">
                  {t("save_rules")}
                </Button>
              </form>
            </Tab.Pane>

            {/* System Settings */}
            <Tab.Pane eventKey="SystemSettings">
              <h4>{t("system_parameters")}</h4>
              <form>
                <div className="mb-3">
                  <label className="form-label">{t("max_seats_per_school")}</label>
                  <input className="formInput" type="number" />
                </div>
                <div className="mb-3">
                  <label className="form-label">{t("enable_notifications")}</label>
                  <select className="formSelect">
                    <option>{t("yes")}</option>
                    <option>{t("no")}</option>
                  </select>
                </div>
                <Button variant="primary" className="mt-3">
                  {t("save_settings")}
                </Button>
              </form>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default SystemConfig;
